<template>
  <div class="compare-attributes main-wrap">
    <!-- <div class="tourbtn"><TourButton @clicked="openTour(true)"></TourButton></div> -->

    <transition name="fade">
      <InfoOverlay
        v-if="!selectedCountry && selectedAttributes.length === 0"
        :description="this.$Strings('compareAttributesInfoCountryAttrMissing')"
      ></InfoOverlay>

      <InfoOverlay
        v-else-if="!selectedCountry"
        :description="this.$Strings('compareAttributesInfoCountryMissing')"
      ></InfoOverlay>

      <InfoOverlay
        v-else-if="selectedAttributes.length === 0"
        :description="this.$Strings('compareAttributesInfoAttrMissing')"
      ></InfoOverlay>
    </transition>

    <div class="viewmode-chart" v-if="viewmode === 'chart'">

      <PreloaderOverlay v-if="$store.state.fetching.length > 0"></PreloaderOverlay>

      <div class="compare-linechart">

        <header class="compare-attributes__header clearfix">
          <div class="inner" v-if="selectedCountry">
            <h1 class="compare-attributes__header__title page-title">{{ selectedCountry.name }}</h1>
            <DownloadShare page="CompareAttributes" class="compare-attributes__header__downloadshare"></DownloadShare>
          </div>
          <div class="inner" v-else>
            <h1 class="compare-attributes__header__title page-title">&nbsp;</h1>
            <DownloadShare page="CompareAttributes" class="compare-attributes__header__downloadshare"></DownloadShare>
          </div>
        </header>

        <section class="comparison-chart">
          <header class="comparison-chart__header">
            <LinechartSelectedLabels
              class="comparison-chart__header__labels"
              :data="formattedChartData"
              ></LinechartSelectedLabels>
            <ConfidenceIntervals
              class="comparison-chart__header__ci"
              :showConfidenceIntervals="this.$store.state.confidenceIntervals"
              @toggleInterval="toggleInterval"
            ></ConfidenceIntervals>
          </header>

          <LineChart :data="formattedChartData" :visibleRange="dateRange" :showConfidenceInterval="this.$store.state.confidenceIntervals"></LineChart>
        </section><!-- /.comparison-chart -->

        <range-year-slider :style="{ 'margin-top': '40px' }" :years="$store.state.defaultYears"></range-year-slider>
      </div>
    </div>

    <ViewModeTable :showAttributes="this.$store.state.attributes.selected" v-if="viewmode === 'table'" :sortingKey="'ID_year'" :data="tableData" :dateRange="dateRange"></ViewModeTable>

  </div><!-- /.compare-attributes -->
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

import rangeYearSlider from '../shared/sliders/RangeYearSlider.vue'
import LineChart from '../shared/charts/LineChart.vue'
import tutorial from '../tutorials/CompareAttributesTutorial.vue'
import InfoOverlay from '../shared/misc/InfoOverlay.vue'
import PreloaderOverlay from '../shared/misc/PreloaderOverlay.vue'
import DownloadShare from '../shared/misc/DownloadShare.vue'
import ConfidenceIntervals from '../shared/misc/ConfidenceIntervals.vue'
import LinechartSelectedLabels from '../shared/charts/LinechartSelectedLabels.vue'
import TourButton from '../tour/tourButton'

import ViewModeTable from './ViewModeTable'

import {EventBus} from '@/event-bus.js'

export default {
  name: 'compare-attributes',
  components: { TourButton, ViewModeTable, PreloaderOverlay, ConfidenceIntervals, DownloadShare, rangeYearSlider, LineChart, LinechartSelectedLabels, tutorial, InfoOverlay },
  data () {
    return {
      CancelToken: axios.CancelToken,
      cancel () {},
      chartData: []
    }
  },
  watch: {
    selectedCountry () {
      this.loadData()
    },
    selectedAttributes () {
      // All attributes are loaded anyway
      // so no need to refresh
    },
    dateRange () {
      this.loadData()
    },
    viewmode () {
      this.loadData()
    }
  },

  methods: {
    openTour (forceOpen) {
      EventBus.$emit('tour:open', 'compare-attributes', forceOpen, [
        {
          title: this.$Strings('tour_attributes1_title'),
          content: this.$Strings('tour_attributes1_description'),
          elementId: false
        },
        {
          title: this.$Strings('tour_attributes2_title'),
          content: this.$Strings('tour_attributes2_description'),
          elementId: 'countries-nav'
        },
        {
          title: this.$Strings('tour_attributes3_title'),
          content: this.$Strings('tour_attributes3_description'),
          elementId: 'attribute-nav'
        },
        {
          title: this.$Strings('tour_attributes4_title'),
          content: this.$Strings('tour_attributes4_description'),
          elementId: 'range-year-slider'
        }
      ])
    },
    /**
     * Loads the navigation data
     * @return {null}
     */
    loadData () {
      if (!this.selectedCountry || !this.dateRange[0] || !this.dateRange[1]) {
        return false
      }

      this.$store.dispatch('startFetching', 'compareAttributes')

      let year1 = this.dateRange[0]
      let year2 = this.dateRange[1]
      let crsId = this.selectedCountry.id

      this.cancel()

      axios.get(process.env.API_URL + 'data/?year1=' + year1 + '&year2=' + year2 + '&crsId=' + crsId, {
        cancelToken: new this.CancelToken((c) => {
          this.cancel = c
        })
      })
        .then((response) => {
          this.$store.dispatch('stopFetching', 'compareAttributes')
          this.chartData = response.data
        })
        .catch((error) => {
          this.$store.dispatch('stopFetching', 'compareAttributes')
          if (!axios.isCancel(error)) {
            EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
            console.log(error)
          }
        })
    },
    toggleInterval () {
      this.$store.state.confidenceIntervals = !this.$store.state.confidenceIntervals
    }
  },
  mounted () {
    this.loadData()
    EventBus.$emit('sidebar-nav', 'CompareAttributes')

    if (
      this.selectedAttributes === undefined || this.selectedAttributes.length === 0 ||
      !this.selectedCountry || this.selectedCountry === undefined
    ) {
      this.$nextTick(this.openTour)
    }
  },
  destroyed () {},
  computed: {
    viewmode () {
      return this.$store.state.viewMode
    },
    dateRange () {
      return this.$store.state.rangeYearSliderCurrent
    },
    selectedCountry () {
      return this.$store.getters['rsc/firstSelected']
    },
    selectedAttributes () {
      return this.$store.state.attributes.selected
    },
    tableData () {
      if (this.selectedAttributes.length === 0 || !this.selectedCountry) {
        return []
      }
      return this.chartData
    },
    formattedChartData () {
      let dataset = []

      _.each(this.selectedAttributes, (attr) => {
        let name = this.$store.getters['attributes/labelInfo'](attr, 'name')
        let color = this.$store.getters.getSelectionColor(attr)

        dataset[attr] = {
          name: name,
          color: color,
          yearData: {}
        }
        _.each(this.chartData, (row) => {
          dataset[attr].yearData[row.ID_year] = {}
          dataset[attr].yearData[row.ID_year].point = row[attr]
          dataset[attr].yearData[row.ID_year].high = row[attr + '_U']
          dataset[attr].yearData[row.ID_year].low = row[attr + '_L']
        })
      })

      return _.values(dataset)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';
  @import '~@/components/sass/shared/helpers';

  .compare-attributes__header{
    // margin-bottom: 10px;
  }

  .compare-attributes__header .inner{
    display: flex; -js-display: flex;
    flex-wrap: nowrap;
    width: 100%;

    .compare-attributes__header__title{
      flex: 1 1 auto;
      width: 100%;
    }
  }

  .comparison-chart__header{
    display: flex; -js-display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .comparison-chart__header__options{
      flex: 0 0 auto;
      margin-top: 15px;
  }

  .comparison-chart__header__labels{
    align-self: flex-end;
    flex: 1 1 0px; -js-flex: 1 1 0px;
  }

  .comparison-chart__header__ci{
    white-space: nowrap;
  }

  .tourbtn {
    position: absolute;
    left: 20px;
    top: -40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/CompareAttributes.vue